module.exports = __webpack_public_path__ + "fonts/plan_table_check.svg";